export { distanceToSlideOnTouchMove } from 'src/components/templates/CatalogPage/services/sliderServices';
import {
  ITouchActionX,
  ISliderInfo,
  getSlideTouchCheck,
  getPagePositionCheck,
} from 'src/components/templates/CatalogPage/services/sliderServices';

export const currentPageXPosition = (page: number, sliderWidth = 0) => {
  switch (page) {
    case 1:
      return 0;
    case 2:
      return sliderWidth;
    default:
      return 2 * sliderWidth;
  }
};

const getPageTapBoundaries = (sliderWidth: number) => {
  const previousPageTapBoundaryX = sliderWidth / 6;
  const nextPageTapBoundaryX = sliderWidth - previousPageTapBoundaryX;

  return { previousPageTapBoundaryX, nextPageTapBoundaryX };
};

export const isZoomDoubleTapArea = (
  doubleTapX: number,
  sliderWidth: number,
) => {
  const { previousPageTapBoundaryX, nextPageTapBoundaryX } =
    getPageTapBoundaries(sliderWidth);

  return (
    doubleTapX > previousPageTapBoundaryX && doubleTapX < nextPageTapBoundaryX
  );
};

export enum MobileGoToAction{
  nextPageSwipe = 'nextPageSwipe',
  previousPageSwipe = 'previousPageSwipe',
  nextPageTap = 'nextPageTap',
  previousPageTap = 'previousPageTap',
  currentPage = 'currentPage'
}

export const shouldGoTo = (
  touch: ITouchActionX,
  slider: ISliderInfo,
  sliderWidth: number,
) => {
  const { isNextPageSlideTouch, isPreviousPageSlideTouch, isTap } =
    getSlideTouchCheck(touch, sliderWidth);
  const { isLastPage, isFirstPage } = getPagePositionCheck(slider);
  const { previousPageTapBoundaryX, nextPageTapBoundaryX } =
    getPageTapBoundaries(sliderWidth);
  const isNextPageTap = isTap && touch.endX > nextPageTapBoundaryX;
  const isPreviousPageTap = isTap && touch.endX < previousPageTapBoundaryX;

  if (isNextPageSlideTouch && !isLastPage) {
    return MobileGoToAction.nextPageSwipe;
  } else if (isNextPageTap && !isLastPage){
    return MobileGoToAction.nextPageTap
  } else if (isPreviousPageSlideTouch && !isFirstPage) {
    return MobileGoToAction.previousPageSwipe;
  } else if (isPreviousPageTap && !isFirstPage){
    return MobileGoToAction.previousPageTap
  } else {
    return MobileGoToAction.currentPage;
  }
};
